import React from "react";
import Cookies from "js-cookie";
import { connect } from "react-redux";
import { addToCart } from "../../actions/actions";
import Modal from "../../components/Modal";
import Button from "../../components/inputs/Button";
import Checkbox from "../../components/inputs/Checkbox";
import Textfield from "../../components/inputs/Textfield";
import Selectbox from "../../components/inputs/Selectbox";
import Loader from "../../components/Loader";
import moment from "moment";
import reqwest from "reqwest";
import queryString from "query-string";
import swal from "sweetalert";
import RenderHTML from "../../components/RenderHTML";
import Radio from "../../components/inputs/Radio";

class SearchResultItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingSpinner: false,
      openModal: false,
      confirmModal: false,
      confirmModalAction: () => null
    };
    this._addToCart = this._addToCart.bind(this);
    this._toggleConfirm = this._toggleConfirm.bind(this);
    this._submitAddToCart = this._submitAddToCart.bind(this);
    this._quickAddToCart = this._quickAddToCart.bind(this);
    this._closeModal = this._closeModal.bind(this);
    this._fetchSellingInfo = this._fetchSellingInfo.bind(this);

    this._queryString = queryString.parse(window.location.href);
  }

  componentWillMount() {
    this._fetchSellingInfo();
  }

  _toggleConfirm(action = () => null) {
    const clientInfo = this.props.data.clientInfo;
    const orderHistory = clientInfo && clientInfo.orderHistory;

    if (orderHistory) {
      this.setState({
        confirmModal: true,
        confirmModalAction: action
      });
    } else {
      action();
    }
  }
  _addToCart() {
    this.setState({
      confirmModal: false,
      confirmModalAction: () => null,
      modalOpen: true
    });
  }
  _submitAddToCart() {
    const clientInfo = this.props.data.clientInfo;
    const orderHistory = clientInfo && clientInfo.orderHistory;

    const volumeInfo = this.props.data.volumeInfo || {};
    const title = volumeInfo.title || "";
    const authors = volumeInfo.authors || "";
    const isbn = `${volumeInfo.isbn13}` || "";
    const publisher = volumeInfo.publisher || "";
    const publishedYear = volumeInfo.publishedYear || "";
    const weight = volumeInfo.weight || "";

    const kref = this._kref._input.value || "";
    const code = this._code._input.value || "";
    const copy = this._copy._input.value || "1";
    const urgt = this._urgt._input.checked ? "1" : "0";
    const details = this._details._input.value || "";
    const ebrary = this.state.ebrary || "";

    let showMarc = false;
    let showSpine = false;
    if (clientInfo) {
      showMarc = clientInfo.showmarc == "1" ? true : false;
      showSpine = clientInfo.showspine == "1" ? true : false;
    }

    let mrkr = 0;
    let mrkrsb = "";
    let mrkrsc = "";
    let mrkrsh = "";
    let mrkrsl = "";
    let mrkrsx = "";
    let mrkrsz = "";

    let spine = 0;
    let spinecolor = "";
    let spineline1 = "";
    let spineline2 = "";
    let spineline3 = "";
    let spineline4 = "";

    if (showMarc && this.state.marcRecord) {
      mrkr = 1;
      mrkrsb = this._subfieldB._input.value || "";
      mrkrsc = this._subfieldC._input.value || "";
      mrkrsh = this._subfieldH._input.value || "";
      mrkrsl = this._subfieldL._input.value || "";
      mrkrsx = this._subfieldX._input.value || "";
      mrkrsz = this._subfieldZ._input.value || "";
    }
    if (showSpine && this.state.spineLabel) {
      spine = 1;
      spinecolor = this.state.color || "";
      spineline1 = this._line1._input.value || "";
      spineline2 = this._line2._input.value || "";
      spineline3 = this._line3._input.value || "";
      spineline4 = this._line4._input.value || "";
    }

    if (Cookies.get("referenceMandatory") == "1" && kref == "") {
      swal({
        title: "Please fill out mandatory fields",
        text: `Please fill out all fields marked with *`,
        showConfirmButton: true,
        type: "error",
        allowOutsideClick: false
      });
      return;
    }

    if (Cookies.get("budgetcodeMandatory") == "1" && code == "") {
      swal({
        title: "Please fill out mandatory fields",
        text: `Please fill out all fields marked with *`,
        showConfirmButton: true,
        type: "error",
        allowOutsideClick: false
      });
      return;
    }

    this.setState({
      confirmModal: false,
      confirmModalAction: () => null,
      modalOpen: false
    });

    this.props.addToCart(Cookies.get("subaccount"), {
      isbn: isbn,
      titl: title,
      auth: authors,
      kdat: moment().format("DD.MM.YYYY"),
      pdat: publishedYear,
      weig: weight,
      publ: publisher,
      elic: ebrary,
      code: code.toUpperCase(),
      kref,
      copy,
      urgt,
      acceptedduplicateorder: orderHistory ? "1" : "",
      detl: details,
      mrkr,
      mrkrsb,
      mrkrsc,
      mrkrsh,
      mrkrsl,
      mrkrsx,
      mrkrsz,
      spine,
      spinecolor,
      spineline1,
      spineline2,
      spineline3,
      spineline4
    });
    swal({
      title: "Success!",
      text: "Your item was added to the cart.",
      timer: 1200,
      showConfirmButton: false,
      type: "success",
      allowOutsideClick: true
    });
  }
  _quickAddToCart() {
    const volumeInfo = this.props.data.volumeInfo || {};
    const title = volumeInfo.title || "";
    const authors = volumeInfo.authors || "";
    const isbn = `${volumeInfo.isbn13}` || "";
    const publisher = volumeInfo.publisher || "";
    const publishedYear = volumeInfo.publishedYear || "";
    const weight = volumeInfo.weight || "";

    const copy = "1";

    this.props.addToCart(Cookies.get("subaccount"), {
      isbn: isbn,
      titl: title,
      auth: authors,
      kdat: moment().format("DD.MM.YYYY"),
      pdat: publishedYear,
      weig: weight,
      publ: publisher,
      copy,
      mrkr: 0,
      spine: 0
    });

    this._closeModal();

    swal({
      title: "Success!",
      text: "Your item was added to the cart.",
      timer: 1200,
      showConfirmButton: false,
      type: "success",
      allowOutsideClick: true
    });
  }
  _closeModal() {
    this.setState({
      modalOpen: false,
      confirmModal: false,
      confirmModalAction: () => null
    });
  }
  _fetchSellingInfo() {
    this.setState({
      loadingSpinner: true
    });

    const volumeInfo = this.props.data.volumeInfo;
    let isbn = volumeInfo.isbn13;

    if (isbn) isbn = isbn.replace(/-/g, "");

    reqwest({
      url: "//booksearch.delbanco.de/life/searchapi.php",
      data: {
        f: "price",
        account: Cookies.get("subaccount"),
        login: Cookies.get("username"),
        isbn
      },
      method: "get",
      crossOrigin: true,
      success: data => {
        data = JSON.parse(data);
        if (data && data.matches && data.matches.length > 0) {
          this.setState({
            buyingInfo: data.matches[0].buyingInfo,
            sellingInfo: data.matches[0].sellingInfo,
            volumeInfo: data.matches[0].volumeInfo,
            fields: data.matches[0].fields,
            sellingInfoDisabled: true,
            loadingSpinner: false
          });
        } else {
          this.setState({
            sellingInfo: "error",
            sellingInfoDisabled: true,
            loadingSpinner: false
          });
        }
      }
    });
  }
  render() {
    const volumeInfo =
      this.state.volumeInfo || this.props.data.volumeInfo || {};
    const buyingInfo =
      this.state.buyingInfo || this.props.data.buyingInfo || {};
    const clientInfo = this.props.data.clientInfo;
    const fields = this.state.fields || this.props.data.fields || [];
    const sellingInfo = this.state.sellingInfo;

    const ebrary = volumeInfo.availableEbrary;
    const binding = volumeInfo.bindingText;

    const isEbook = ebrary || binding.includes("E-Book") ? true : false;

    let showMarc = false;
    let showSpine = false;
    if (clientInfo) {
      showMarc = clientInfo.showmarc == "1" ? true : false;
      showSpine = clientInfo.showspine == "1" ? true : false;
    }

    return (
      <div className={`Alternation ${isEbook ? "is-eBook" : ""}`}>
        {this.state.loading && <Loader />}
        {ebrary ? (
          <div className="Alternation-imageWrapper">
            <img
              className="Alternation-image"
              src="/images/ebrary.jpg"
              height="65"
            />
            <h4 className="Alternation-title">EBookCentral</h4>
          </div>
        ) : binding.includes("Paperback") ? (
          <div className="Alternation-imageWrapper">
            <img
              className="Alternation-image"
              src="/images/paperback.png"
              alt=""
            />
            <h4 className="Alternation-title">Paperback</h4>
          </div>
        ) : binding.includes("E-Book") ? (
          <div className="Alternation-imageWrapper">
            <img
              className="Alternation-image"
              src="/images/e-book.png"
              alt=""
            />
            <h4 className="Alternation-title">Ebook Publisher</h4>
          </div>
        ) : (
          <div className="Alternation-imageWrapper">
            <img className="Alternation-image" src="/images/book.png" alt="" />
            <h4 className="Alternation-title">Hardcover</h4>
          </div>
        )}
        <div className="item-details">
          {Object.keys(fields).map(key => (
            <div key={key} className="Alternation-info">
              <span className="Alternation-label">{key}</span>
              <span className="Alternation-value">
                <RenderHTML html={` ${fields[key]}`} />
              </span>
            </div>
          ))}
        </div>
        {/*
        <div className="Alternation-info">
          <span className="Alternation-label">
            {isEbook ? "Licenses:" : "ListPrice:"}
          </span>
        </div>
         {buyingInfo && buyingInfo.products ? (
          buyingInfo.products.map(item => {
            return (
              <div key={item.type} className="Alternation-listPrice">
                <span style={{ color: "#333333" }}>{item.Type}:</span>{" "}
                {item.Currency} {item.List_Price}
              </div>
            );
          })
        ) : buyingInfo &&
          buyingInfo.listPrice &&
          buyingInfo.listPrice != "0.00" ? (
          <div className="Alternation-listPrice">
            {buyingInfo.currency} {buyingInfo.listPrice}
          </div>
        ) : (
          <div className="Alternation-listPrice">n/a</div>
        )} */}
        <div className="Alternation-buttons">
          {this.state.loadingSpinner ? (
            <div className="spinner" />
          ) : (
            sellingInfo &&
            sellingInfo.offers && (
              <div>
                {(this.state.selectedOffer &&
                  `${this.state.selectedOffer.currency} ${sellingInfo.offers[0].price}`) ||
                  `${sellingInfo.offers[0].currency} ${sellingInfo.offers[0].price}`}
                <hr />
                {sellingInfo.offers.map((item, index) => {
                  return (
                    <Radio
                      key={item.textDescription}
                      defaultChecked={index === 0}
                      label={item.description}
                      value={item}
                      discriminator={item.textDescription}
                      onclick={value => {
                        this.setState({
                          selectedOffer: value
                        });
                      }}
                      name={`offers-${volumeInfo.isbn13}`}
                    />
                  );
                })}
              </div>
            )
          )}
          <Button
            disabled={Cookies.get("orderpermit") == "0"}
            type="primary"
            onClick={() => this._toggleConfirm(this._addToCart)}
          >
            Add to Cart <br /> (incl. reference)
          </Button>
          <Modal open={this.state.modalOpen} onClose={this._closeModal}>
            <Textfield
              ref={node => (this._kref = node)}
              placeholder={Cookies.get("referenceText")}
              required={Cookies.get("referenceMandatory") == "1"}
              defaultValue={`${
                this._queryString.initialsPrefixRef == 1
                  ? Cookies.get("firstname").charAt(0) +
                    Cookies.get("lastname").charAt(0)
                  : ""
              }${
                this._queryString.standardRef
                  ? this._queryString.standardRef
                  : ""
              }`}
            />
            <Textfield
              ref={node => (this._code = node)}
              placeholder="Your Budget Code"
              required={Cookies.get("budgetcodeMandatory") == "1"}
              autocompleteBudgetCode={Cookies.get("subaccount")}
            />
            <Textfield
              type="number"
              ref={node => (this._copy = node)}
              placeholder="Copies"
              defaultValue="1"
            />
            <Textfield
              ref={node => (this._kdat = node)}
              disabled={true}
              value={moment().format("DD.MM.YYYY")}
              placeholder="Order Date"
            />
            <Checkbox
              ref={node => (this._urgt = node)}
              onClick={value => value}
              value="1"
              label="Urgent"
              name={`urgent_${volumeInfo.isbn13}`}
            />
            <Textfield
              type="textarea"
              ref={node => (this._details = node)}
              placeholder="Details"
            />
            {buyingInfo.products && buyingInfo.products.length ? (
              <Selectbox
                alignLabel="top"
                label="License:"
                updateAction={value => this.setState({ ebrary: value })}
                options={buyingInfo.products.map(item => {
                  return {
                    name: `${item.Type} (${item.Currency} ${item.List_Price})`,
                    value: `${item.Type}:${item.Currency}${item.List_Price}`
                  };
                })}
              />
            ) : null}
            {showMarc && (
              <div>
                <hr />
                <Checkbox
                  name={`marcRecord_${volumeInfo.isbn13}`}
                  onclick={value =>
                    this.setState({
                      marcRecord: value
                    })
                  }
                  value="true"
                  label="Marc-Record"
                />
                {this.state.marcRecord && (
                  <div>
                    <div style={{ margin: "10px" }}>Marc-Record field 852:</div>
                    <Textfield
                      ref={node => (this._subfieldB = node)}
                      placeholder="Subfield b"
                    />
                    <Textfield
                      ref={node => (this._subfieldC = node)}
                      placeholder="Subfield c"
                    />
                    <Textfield
                      ref={node => (this._subfieldH = node)}
                      placeholder="Subfield h"
                    />
                    <Textfield
                      ref={node => (this._subfieldL = node)}
                      placeholder="Subfield l"
                    />
                    <Textfield
                      ref={node => (this._subfieldX = node)}
                      placeholder="Subfield x"
                    />
                    <Textfield
                      ref={node => (this._subfieldZ = node)}
                      placeholder="Subfield z"
                    />
                  </div>
                )}
              </div>
            )}
            {showSpine && (
              <div>
                <hr />
                <Checkbox
                  name={`spineLabel_${volumeInfo.isbn13}`}
                  onclick={value =>
                    this.setState({
                      spineLabel: value
                    })
                  }
                  value="true"
                  label="Spine Label"
                />
                {this.state.spineLabel && (
                  <div>
                    <Selectbox
                      alignLabel="top"
                      label="Color:"
                      updateAction={value => this.setState({ color: value })}
                      options={[
                        {
                          name: `White`,
                          value: `white`
                        },
                        {
                          name: `Red`,
                          value: `red`
                        },
                        {
                          name: `Blue`,
                          value: `blue`
                        },
                        {
                          name: `Yellow`,
                          value: `yellow`
                        },
                        {
                          name: `Green`,
                          value: `green`
                        }
                      ]}
                    />
                    <Textfield
                      ref={node => (this._line1 = node)}
                      placeholder="Line 1"
                    />
                    <Textfield
                      ref={node => (this._line2 = node)}
                      placeholder="Line 2"
                    />
                    <Textfield
                      ref={node => (this._line3 = node)}
                      placeholder="Line 3"
                    />
                    <Textfield
                      ref={node => (this._line4 = node)}
                      placeholder="Line 4"
                    />
                  </div>
                )}
              </div>
            )}
            <div className="button-wrapper">
              <Button type="danger" onClick={this._closeModal}>
                Cancel
              </Button>
              <Button type="primary" onClick={this._submitAddToCart}>
                Add to Cart
              </Button>
            </div>
          </Modal>
          <Modal open={this.state.confirmModal} onClose={this._closeModal}>
            <p>
              You already ordered this book once. <br />
              Are you sure, you want to order it again?
            </p>
            <div className="button-wrapper">
              <Button type="danger" onClick={this._closeModal}>
                No
              </Button>
              <Button
                type="primary"
                onClick={() => this.state.confirmModalAction()}
              >
                Yes, add to Cart
              </Button>
            </div>
          </Modal>
        </div>
      </div>
    );
  }
}

SearchResultItem.propTypes = {
  data: React.PropTypes.object,
  addToCart: React.PropTypes.func
};

const mapDispatchToProps = dispatch => {
  return {
    addToCart: (subaccount, item) => {
      dispatch(addToCart(subaccount, item));
    }
  };
};

export default connect(null, mapDispatchToProps)(SearchResultItem);



// WEBPACK FOOTER //
// ./src/js/routes/bookCatalogue/ResultItemAlternation.js